(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sandland-tracking"] && !Shopify.designMode) return;
  try {
    
const initializeSandlandTracking=root=>{
  if(root.dataset.initialized)return;
  root.dataset.initialized='true';
  const one=query=>root.querySelector(query);
  const put=(query,value)=>{one(query).textContent=value??''};
  const params=new URLSearchParams(location.search);
  const id=params.get('id')?.trim();
  if(location.hash.startsWith('#access='))history.replaceState(null,'',location.pathname+location.search);
  if(id)one('[data-order-input]').value=id;
  let guides={};
  try{guides=JSON.parse(one('[data-guides]').textContent)}catch{}
  const formatDate=value=>{if(!value)return '';const parsed=new Date(value);return Number.isNaN(parsed.getTime())?'':new Intl.DateTimeFormat(document.documentElement.lang||'en-US',{month:'long',day:'numeric',year:'numeric'}).format(parsed)};
  const error=()=>{one('[data-loading]').hidden=true;one('[data-order-content]').hidden=true;one('[data-lookup]').hidden=false;one('[data-error]').hidden=false};
  const render=order=>{
    one('[data-loading]').hidden=true;
    one('[data-error]').hidden=true;
    one('[data-lookup]').hidden=true;
    one('[data-order-content]').hidden=false;
    const shipment=order.shipment||{};
    const status=shipment.status||'confirmed';
    const headline=one('[data-page-heading]');const intro=one('[data-page-intro]');const deliveryLabel=one('[data-delivery-label]');
    headline.textContent=status==='delivered'?headline.dataset.delivered:status==='delayed'?headline.dataset.delayed:headline.dataset.default;
    intro.textContent=status==='delivered'?intro.dataset.delivered:status==='delayed'?intro.dataset.delayed:intro.dataset.default;
    deliveryLabel.textContent=status==='delivered'?deliveryLabel.dataset.delivered:deliveryLabel.dataset.default;
    const labels={confirmed:'Order confirmed',shipped:'Shipped',transit:'On its way',delivered:'Delivered',delayed:'Delivery delayed'};
    put('[data-status]',labels[status]||labels.confirmed);
    put('[data-carrier]',shipment.carrier||'');
    put('[data-arrival]',formatDate(shipment.estimatedDeliveryAt)||formatDate(shipment.deliveredAt)||(status==='confirmed'?'Preparing your order':'Waiting for a carrier update'));
    put('[data-arrival-detail]',shipment.arrivalDetail||'');
    put('[data-message]',shipment.message||'');
    put('[data-updated]',shipment.updatedAt?'Last updated '+formatDate(shipment.updatedAt):'');
    const step={confirmed:0,shipped:1,transit:2,delayed:2,delivered:3}[status]??0;
    root.querySelectorAll('[data-step]').forEach((node,index)=>{node.classList.toggle('is-done',index<step);node.classList.toggle('is-active',index===step);if(index===step)node.setAttribute('aria-current','step');else node.removeAttribute('aria-current')});
    const events=one('[data-events]');events.replaceChildren();
    (shipment.events||[]).forEach(event=>{const li=document.createElement('li');const time=document.createElement('time');time.textContent=formatDate(event.at);const body=document.createElement('span');body.textContent=event.message||event.status||'';li.append(time,body);events.append(li)});
    one('[data-updates-wrap]').hidden=!events.children.length;
    if(shipment.trackingUrl&&/^https:\/\//.test(shipment.trackingUrl)){const link=one('[data-carrier-link]');link.href=shipment.trackingUrl;link.hidden=false}
    const items=Array.isArray(order.items)?order.items:[];
    put('[data-item-count]',items.length+' '+(items.length===1?'product':'products'));
    put('[data-order-name]',order.name||'');
    const list=one('[data-items]');list.replaceChildren();
    const selector=one('[data-product-select]');selector.replaceChildren();
    items.forEach((item,index)=>{
      const li=document.createElement('li');
      if(item.image&&/^https:\/\//.test(item.image)){const img=document.createElement('img');img.src=item.image;img.alt='';img.loading='lazy';li.append(img)}
      const info=document.createElement('div');const title=document.createElement('strong');title.textContent=item.title||'Product';info.append(title);
      if(item.variantTitle){const variant=document.createElement('small');variant.textContent=item.variantTitle;info.append(variant)}
      const qty=document.createElement('small');qty.textContent='Qty '+(item.quantity||1);info.append(qty);
      if(item.price){const price=document.createElement('small');price.textContent=item.price;info.append(price)}
      li.append(info);list.append(li);
      const option=document.createElement('option');option.value=String(index);option.textContent=item.title||'Product';selector.append(option)
    });
    const expand=one('[data-expand]');expand.hidden=items.length<=2;
    expand.onclick=()=>{const open=expand.getAttribute('aria-expanded')!=='true';expand.setAttribute('aria-expanded',String(open));one('.stp__order').classList.toggle('is-expanded',open);expand.textContent=open?'Show fewer products ↑':'Show all products ↓'};
    const renderGuide=()=>{
      const item=items[Number(selector.value)||0];const guide=guides[item?.handle];const area=one('[data-product-directions]');area.replaceChildren();
      if(!guide||![guide.step1,guide.step2,guide.step3].some(Boolean)){const p=document.createElement('p');p.className='stp__directions-caution';p.textContent='Directions for this product are being updated.';area.append(p);return}
      const ul=document.createElement('ol');ul.className='stp__direction-list';
      [guide.step1,guide.step2,guide.step3].filter(Boolean).forEach((value,index)=>{const li=document.createElement('li');const badge=document.createElement('b');badge.textContent=String(index+1);const p=document.createElement('p');p.textContent=value;li.append(badge,p);ul.append(li)});area.append(ul);
      if(guide.link){const a=document.createElement('a');a.className='stp__direction-link';a.href=guide.link;a.textContent='Full directions and ingredients ↗';area.append(a)}
    };
    selector.onchange=renderGuide;renderGuide();
    const audience=['first','repeat','subscriber'].includes(order.audience)?order.audience:'repeat';
    const hero=root.querySelector('[data-hero="'+audience+'"]')||root.querySelector('[data-hero="repeat"]');if(hero)hero.hidden=false
  };
  if(root.dataset.designMode==='true'){
    render({name:'#SL10482',audience:'first',items:[{title:'Stay Asleep',handle:'stay-asleep',quantity:1}],shipment:{status:'transit',carrier:'USPS',message:'Your order is on its way.',events:[{at:new Date().toISOString(),message:'In transit'}]}});
    document.addEventListener('shopify:block:select',event=>{const selected=event.target.closest('.stp__hero');if(selected&&root.contains(selected)){root.querySelectorAll('.stp__hero').forEach(hero=>hero.hidden=hero!==selected)}});
    return
  }
  if(!id)return;
  if(!root.dataset.endpoint){error();return}
  one('[data-lookup]').hidden=true;
  one('[data-loading]').hidden=false;
  fetch(root.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id}),cache:'no-store',credentials:'omit'}).then(async response=>{if(!response.ok)throw Error('Tracking unavailable');return response.json()}).then(render).catch(error)
};
document.querySelectorAll('.stp').forEach(initializeSandlandTracking);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.stp').forEach(initializeSandlandTracking));

  } catch(e) { console.error(e); }
})();
})();
